import axios from 'axios';

export const api = axios.create({
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
});

// Inject authenticity token
api.interceptors.request.use(request => {
  if (process.env.RAILS_ENV == 'test') {
    return request;
  }

  if (request.method != 'get') {
    var csrf = document.head.querySelector('[name=csrf-token]');
    if (csrf == null) {
      return request;
    }
    if (request.data) {
      request.data.authenticity_token = csrf.content;
    } else {
      request.data = {
        authenticity_token: csrf.content,
      };
    }
  }
  return request;
});

// Update authenticity token
api.interceptors.response.use(
  response => {
    if (process.env.RAILS_ENV == 'test') {
      return response;
    }

    if (response.config.method != 'get') {
      document.head.querySelector('[name=csrf-token]').setAttribute('content', response.headers['x-csrf-token']);
    }
    return response;
  },
  error => {
    console.log(error);
    if (error.response.config.method != 'get') {
      document.head.querySelector('[name=csrf-token]').setAttribute('content', error.response.headers['x-csrf-token']);
    }
    return Promise.reject(error);
  }
);
